import { ShortCode } from '@highereducation/wordpress';

interface SeoSchemaShortcodeProps {
  type?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * SeoSchemaShortcode — invisible wrapper that declares a schema.org section.
 *
 * Replaces `<div data-seo-schema="HowTo">` with
 * `[hen-seo-schema type="HowTo"]...[/hen-seo-schema]`.
 *
 * Renders children as-is (no DOM output). Schema data is extracted at
 * enrichment time by `getSeoFromShortcodes`, not at render time.
 *
 * @example
 * [hen-seo-schema type="HowTo"]
 *   [hen-seo-data role="howto-title"]
 *     [hen-ui-heading variant="h2"]Steps to Become...[/hen-ui-heading]
 *   [/hen-seo-data]
 * [/hen-seo-schema]
 */
export const SeoSchemaShortcode: ShortCode<SeoSchemaShortcodeProps> = {
  balanced: true,
  component: ({ children }) => <>{children}</>,
};
